import React, { Component } from 'react';
import './../css/master.css';
import './../css/wvrPOProgressUpdate.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const { IMG_TYPES } = require('./imgType')

var httpURL = '';
var queryString = require('querystring');
var lstPo = [];
var sortVal = "";
var COL_PO_QUOTEID = 'td:eq(0)';
var COL_PO_POID = 'td:eq(1)';
var COL_PO_PONO = 'td:eq(2)';
var COL_PO_ASIGNDATE = 'td:eq(3)';
var COL_PO_DESIGNID = 'td:eq(4)';
var COL_PO_DESIGNNOCOLOR = 'td:eq(5)';
var COL_PO_CSDELIVERYDT = 'td:eq(6)';
var COL_PO_LENGTH = 'td:eq(7)';
var COL_PO_WIDTH = 'td:eq(8)';
var COL_PO_CONSTRUCTION = 'td:eq(9)';
var COL_PO_YARNCOUNT = 'td:eq(10)';
var COL_PO_QUALITY = 'td:eq(11)';
var COL_PO_RATE = 'td:eq(12)';
var COL_PO_MOQ = 'td:eq(13)';
var COL_PO_MOR = 'td:eq(14)';
var COL_PO_ACTION = 'td:eq(15)';
var COL_PO_NOTES = 'td:eq(16)';
var COL_PO_IPODESIGNID = 'td:eq(18)';

class IpoProgressUpdate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			po: [],
			loader: 'none',
			opacity: 1,
			width: '97.6%',
		}
	}

	async componentDidMount() {
		var weaverId = sessionStorage.getItem('weaverId');
		this.setState({ loader: 'block', opacity: 0.5 });
		await axiosInstance.post(httpURL + '/w/po/listpodesign',
			queryString.stringify({ 'weaverId': weaverId }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					po: response.data.lstAllPoDesign,
				});
				lstPo = this.state.po;
				this.setPOTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		var width = ($('.tableLayout1').parent().width()) - 17;
		this.setState({ width: width });
	}

	setPOTable = () => {
		$('#poTableBody tr').remove();
		var table = document.getElementById('poTable');
		var tbody = document.getElementById('poTableBody');
		var filterPoNo = $('#poNo').val().trim().toLowerCase();
		var filterDesignColor = $('#designNoColor').val().trim().toLowerCase();

		for (var i = 0; i < lstPo.length; i++) {
			var quoteId = lstPo[i].quoteId;
			var ipoId = lstPo[i].ipoId;
			var ipoNo = lstPo[i].ipoNo == null ? '' : lstPo[i].ipoNo;
			var assignDt = lstPo[i].assignedDate === null ? '-' : lstPo[i].assignedDate;
			var id = lstPo[i].designId;
			var designColor = lstPo[i].designNoColor == null ? '' : lstPo[i].designNoColor;
			var designImage = lstPo[i].img;
			var csDeliveryDt = lstPo[i].deliveryDate;
			var length = lstPo[i].length == 0 ? '' : lstPo[i].length;
			var width = lstPo[i].width == null ? '' : lstPo[i].width;
			var construction = lstPo[i].construction;
			var yarnCount = lstPo[i].yarnCount;
			var quality = lstPo[i].quality;
			var rate = lstPo[i].rate == 0 ? '' : lstPo[i].rate;
			var moq = lstPo[i].moQ == 0 ? '' : lstPo[i].moQ;
			var mor = lstPo[i].moR == 0 ? '' : lstPo[i].moR;
			var notes = lstPo[i].notes;
			var ipoDesignId = lstPo[i].ipoDesignId;
			var status = lstPo[i].status;

			var row = document.createElement('tr');
			row.onclick = (e) => {
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			}

			if (ipoNo.toLowerCase().indexOf(filterPoNo) === -1)
				continue;
			if (designColor.toLowerCase().indexOf(filterDesignColor) === -1)
				continue;

			this.addTD(row, quoteId, 'text-right');
			this.addTD(row, ipoId, 'no-display');
			this.addTD(row, ipoNo, '');
			this.addTD(row, assignDt, 'text-center');
			this.addTD(row, id, 'no-display');
			this.addTD(row, designColor, '');
			this.addTD(row, csDeliveryDt, 'text-center');
			this.addTD(row, length, 'text-right');
			this.addTD(row, width, '');
			this.addTD(row, construction, '');
			this.addTD(row, yarnCount, '');
			this.addTD(row, quality, '');
			this.addTD(row, rate, 'text-right');
			this.addTD(row, moq, 'text-right');
			this.addTD(row, mor, 'text-right');
			this.addTD(row, status, 'text-center');
			this.addTDOption(row, 'glyphicon glyphicon-option-vertical', 'text-center');
			this.addTDNotes(row, notes, '');
			this.addTD(row, ipoDesignId, 'no-display');
			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;

		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	addTDImage(row, val, classname) {
		var date = new Date();
		var cell = document.createElement('td');
		cell.className = classname;
		var img = document.createElement('img');
		img.style.width = '20px';
		img.style.height = '20px';

		if (val == '') {
			img.src = require("../images/logo.png");
		} else if (val != null) {
			img.src = window.httpURL + "/a/mst/dsn/getImage?img=" + val + '&imgType=' + IMG_TYPES.THUMB;
		} else {
			img.src = require("../images/logo.png");
		}
		cell.append(img);
		row.append(cell);
	}

	addTDNotes(row, val, classname) {
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.style.whiteSpace = 'nowrap';
		cell.style.overflow = 'hidden';
		cell.style.textOverflow = 'ellipsis';
		cell.dataset.note = val;
		cell.addEventListener('mousemove', this.openNotes);
		cell.append(text);
		row.append(cell);
	}

	addTDOption(row, val, classname) {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.position = 'relative';
		span.style.cursor = 'pointer';

		var ul = document.createElement('ul');
		ul.className = 'ulStyle1';
		var li1 = document.createElement('li');
		var li2 = document.createElement('li');
		var li3 = document.createElement('li');

		li1.innerHTML = 'Update Progress';
		li2.innerHTML = 'Work Done';
		li3.innerHTML = 'Dispatch';

		li1.onclick = () => {
			this.progress();
		};

		li2.onclick = () => {
			this.workDone();
		};

		li3.onclick = () => {
			this.dispatch();
		};

		ul.append(li1);
		ul.append(li2);
		ul.append(li3);

		span.onclick = (e) => {
			$(ul).toggle();
			$(e.target.closest('tr')).siblings().find('span ul').hide();
			$(e.target.closest('tr')).addClass('selected').siblings().removeClass('selected');
		};
		span.append(ul);
		cell.append(span);
		row.append(cell);
	}

	progress = () => {
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		var ipoNo = $('#poTableBody tr.selected').find(COL_PO_PONO).text();
		var designId = $('#poTableBody tr.selected').find(COL_PO_DESIGNID).text();
		var designNoColor = $('#poTableBody tr.selected').find(COL_PO_DESIGNNOCOLOR).text();
		var ipoDesignId = $('#poTableBody tr.selected').find(COL_PO_IPODESIGNID).text();
		var quality = $('#poTableBody tr.selected').find(COL_PO_QUALITY).text();
		var length = $('#poTableBody tr.selected').find(COL_PO_LENGTH).text();
		var width = $('#poTableBody tr.selected').find(COL_PO_WIDTH).text();
		var yarnCount = $('#poTableBody tr.selected').find(COL_PO_YARNCOUNT).text();
		var construction = $('#poTableBody tr.selected').find(COL_PO_CONSTRUCTION).text();
		var imageName = this.getImageName(ipoDesignId);
		if (imageName != -1) {
			var imageUrl = window.httpURL + "/a/mst/dsn/getImage?img=" + imageName + '&imgType=' + IMG_TYPES.DSN;
		}

		if (ipoId !== '' || ipoId !== null) {
			if (ipoDesignId === '' || ipoDesignId === null || ipoDesignId === 0) {
				toast.warning('You can not update progress for this design');
				return false;
			}
			this.props.history.push({
				pathname: '/wvr/progressUpdate',
				state: { detail: { 'ipoDesignId': ipoDesignId, 'ipoId': ipoId, 'ipoNo': ipoNo, 'designId': designId, 'designNoColor': designNoColor, 'quality': quality, 'length': length, 'width': width, 'yarnCount': yarnCount, 'construction': construction, 'imageUrl': imageUrl } }
			});
		}
	}

	dispatch = () => {
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		var ipoNo = $('#poTableBody tr.selected').find(COL_PO_PONO).text();
		var designId = $('#poTableBody tr.selected').find(COL_PO_DESIGNID).text();
		var designNoColor = $('#poTableBody tr.selected').find(COL_PO_DESIGNNOCOLOR).text();
		var ipoDesignId = $('#poTableBody tr.selected').find(COL_PO_IPODESIGNID).text();
		var quality = $('#poTableBody tr.selected').find(COL_PO_QUALITY).text();
		var length = $('#poTableBody tr.selected').find(COL_PO_LENGTH).text();
		var width = $('#poTableBody tr.selected').find(COL_PO_WIDTH).text();
		var yarnCount = $('#poTableBody tr.selected').find(COL_PO_YARNCOUNT).text();
		var construction = $('#poTableBody tr.selected').find(COL_PO_CONSTRUCTION).text();
		var imageName = this.getImageName(ipoDesignId);
		if (imageName != -1) {
			var imageUrl = window.httpURL + "/a/mst/dsn/getImage?img=" + imageName + '&imgType=' + IMG_TYPES.DSN;
		}
		if (ipoId !== '' || ipoId !== null) {
			if (ipoDesignId === '' || ipoDesignId === null || ipoDesignId === 0) {
				toast.warning('You can not update progress for this design');
				return false;
			}
			this.props.history.push({
				pathname: '/wvr/dispatch',
				state: { detail: { 'ipoDesignId': ipoDesignId, 'ipoId': ipoId, 'ipoNo': ipoNo, 'designId': designId, 'designNoColor': designNoColor, 'quality': quality, 'length': length, 'width': width, 'yarnCount': yarnCount, 'construction': construction, 'imageUrl': imageUrl } }
			});
		}
	}

	workDone = () => {
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		var ipoNo = $('#poTableBody tr.selected').find(COL_PO_PONO).text();
		var designId = $('#poTableBody tr.selected').find(COL_PO_DESIGNID).text();
		var designNoColor = $('#poTableBody tr.selected').find(COL_PO_DESIGNNOCOLOR).text();
		var ipoDesignId = $('#poTableBody tr.selected').find(COL_PO_IPODESIGNID).text();
		var quality = $('#poTableBody tr.selected').find(COL_PO_QUALITY).text();
		var length = $('#poTableBody tr.selected').find('td:eq(7)').text();
		var width = $('#poTableBody tr.selected').find(COL_PO_WIDTH).text();
		var yarnCount = $('#poTableBody tr.selected').find(COL_PO_YARNCOUNT).text();
		var construction = $('#poTableBody tr.selected').find(COL_PO_CONSTRUCTION).text();
		var imageName = this.getImageName(ipoDesignId);
		console.log(length);
		if (imageName != -1) {
			var imageUrl = window.httpURL + "/a/mst/dsn/getImage?img=" + imageName + '&imgType=' + IMG_TYPES.DSN;
		}
		if (ipoId !== '' || ipoId !== null) {
			if (ipoDesignId === '' || ipoDesignId === null || ipoDesignId === 0) {
				toast.warning('You can not update progress for this design');
				return false;
			}
			this.props.history.push({
				pathname: '/wvr/workDone',
				state: { detail: { 'ipoDesignId': ipoDesignId, 'ipoId': ipoId, 'ipoNo': ipoNo, 'designId': designId, 'designNoColor': designNoColor, 'quality': quality, 'length': length, 'width': width, 'yarnCount': yarnCount, 'construction': construction, 'imageUrl': imageUrl } }
			});
		}
	}

	openNotes = (e) => {
		$('[data-title]').after().css({ 'top': e.target.offsetTop });
	}

	getImageName = (id) => {
		for (var i = 0; i < lstPo.length; i++) {
			if (lstPo[i].ipoDesignId == id) {
				return lstPo[i].img;
			}
		}
		return -1;
	}

	sortAscByPo = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#poAsDtIcon").css("color", "gray");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "#111");
			$("#delAsDtIcon").css("color", "#111");
			$("#delDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].ipoNo;
				for (var j = i + 1; j < lstPo.length; j++) {
					val2 = lstPo[j].ipoNo;
					if (val1 > val2) {
						var tmp = lstPo[j];
						lstPo[j] = lstPo[i];
						lstPo[i] = tmp;
						val1 = lstPo[i].bpoNo;
					}
				}
			}
			this.setPOTable();
		}
	}

	sortDesByPo = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "gray");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "#111");
			$("#delAsDtIcon").css("color", "#111");
			$("#delDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].ipoNo;
				for (var j = i + 1; j < lstPo.length; j++) {
					val2 = lstPo[j].ipoNo;
					if (val1 < val2) {
						var tmp = lstPo[j];
						lstPo[j] = lstPo[i];
						lstPo[i] = tmp;
						val1 = lstPo[i].ipoNo;
					}
				}
			}
			this.setPOTable();
		}
	}

	sortAscByAssign = () => {
		if (sortVal != 'asasn') {
			sortVal = 'asasn';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "gray");
			$("#assignDsDtIcon").css("color", "#111");
			$("#delAsDtIcon").css("color", "#111");
			$("#delDsDtIcon").css("color", "#111");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].assignedDate;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].assignedDate;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 > dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].assignedDate;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	sortDesByAssign = () => {
		if (sortVal != 'dsasn') {
			sortVal = 'dsasn';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "gray");
			$("#delAsDtIcon").css("color", "#111");
			$("#delDsDtIcon").css("color", "#111");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].assignedDate;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);

					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].assignedDate;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 < dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].assignedDate;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	sortAscByDelivery = () => {
		if (sortVal != 'asdel') {
			sortVal = 'asdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "#111");
			$("#delAsDtIcon").css("color", "gray");
			$("#delDsDtIcon").css("color", "#111");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].deliveryDate;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].deliveryDate;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 > dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].deliveryDate;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	sortDesByDelivery = () => {
		if (sortVal != 'dsdel') {
			sortVal = 'dsdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "#111");
			$("#delAsDtIcon").css("color", "#111");
			$("#delDsDtIcon").css("color", "gray");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].deliveryDate;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);

					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].deliveryDate;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 < dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].deliveryDate;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<WeaverHeader />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<table className="tableLayout1" style={{ width: this.state.width }}>
								<thead>
									<tr>
										<th style={{ width: 30 }}>Quote Id</th>
										<th style={{ width: 50, display: 'none' }}>PO Id</th>
										<th style={{ width: 50 }}>
											<div style={{ float: 'left', width: '80%' }}>
												<input type="text" onChange={this.setPOTable} className="form-control inp-search" id="poNo" placeholder="PO No." />
											</div>
											<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
												<div className="assending">
													<span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
												</div>
												<div className="desending">
													<span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
												</div>
											</div>
										</th>
										<th style={{ width: 50, textAlign: 'left' }}>
											<div style={{ marginLeft: 2 }}>
												<div className="dateLabel">Assign Date</div>
												<div className="sortIcon">
													<div className="assending">
														<span id="assignAsDtIcon" onClick={this.sortAscByAssign} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="assignDsDtIcon" onClick={this.sortDesByAssign} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</div>
										</th>
										<th style={{ width: 50, display: 'none' }}>Design Id</th>
										<th style={{ width: 50 }}>
											<input type="text" onChange={this.setPOTable} className="form-control inp-search" id="designNoColor" placeholder="Design Color" />
										</th>

										<th style={{ width: 50, textAlign: 'left' }}>
											<div style={{ marginLeft: 2 }}>
												<div className="dateLabel">CS Del. Date</div>
												<div className="sortIcon">
													<div className="assending">
														<span id="delAsDtIcon" onClick={this.sortAscByDelivery} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="delDsDtIcon" onClick={this.sortDesByDelivery} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</div>
										</th>
										<th style={{ width: 28 }}>Length</th>
										<th style={{ width: 30 }}>Width</th>
										<th style={{ width: 45 }}>Construction</th>
										<th style={{ width: 50 }}>Yarn Count</th>
										<th style={{ width: 45 }}>Quality</th>
										<th style={{ width: 25 }}>Rate</th>
										<th style={{ width: 25 }}>MOQ</th>
										<th style={{ width: 25 }}>MOR</th>
										<th style={{ width: 60 }}>Status</th>
										<th style={{ width: 30 }}>Action</th>
										<th style={{ width: 50 }}>Notes</th>
										<th style={{ width: 50, display: 'none' }}>IPO Design Id</th>
									</tr>
								</thead>
							</table>
							<div className="col-sm-12 poTableDiv padding-remove">
								<table id="poTable" className="tableLayout">
									<colgroup>
										<col width="30" />
										<col width="50" />
										<col width="50" />
										<col width="50" />
										<col width="50" />
										<col width="28" />
										<col width="30" />
										<col width="45" />
										<col width="50" />
										<col width="45" />
										<col width="25" />
										<col width="25" />
										<col width="25" />
										<col width="60" />
										<col width="30" />
										<col width="50" />
									</colgroup>
									<tbody id="poTableBody"></tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default IpoProgressUpdate;
